
import { h, isVue2, defineComponent } from 'vue-demi';

export default defineComponent({
  name: 'HtmlRenderer',
  inheritAttrs: false,
  props: {
    content: {
      type: [String, null],
      default: '',
    },
    tag: {
      type: String,
      default: 'div',
    },
  },
  setup(props, context) {
    const { attrs, slots } = context;

    return () => {
      const listeners = isVue2 ? (context as any).listeners : undefined;

      const componentAttrs = {
        ...attrs,
        ...(isVue2 && listeners ? { on: listeners } : {}),
      };

      if (props.content) {
        if (isVue2) {
          return h(props.tag, {
            ...componentAttrs,
            domProps: { innerHTML: props.content },
          });
        } else {
          return h(props.tag, {
            innerHTML: props.content,
            ...componentAttrs,
          });
        }
      }

      let children;

      if (isVue2) {
        children = slots.default ? slots.default() : undefined;
      } else {
        children = slots.default?.();
      }

      return h(props.tag, componentAttrs, children);
    };
  },
});
